import { Injectable, Inject } from '@angular/core';
import { Resolve } from '@angular/router';
import { Observable } from 'rxjs';

import { WorkflowService } from '../service';
import { AlertStatus } from '../model';

@Injectable({
  providedIn: 'root'
})
export class GetAlertStatusResolver implements Resolve<AlertStatus[]> {

  constructor(private workflowService: WorkflowService) { }

  resolve(): Observable<AlertStatus[]> {
    return this.workflowService.getAlertStatuses();
  }
}
